<template>
  <div v-show="show" class="job-list-share-popup" :class="showPopup && 'is-active'">
    <div class="popup-mask"></div>
    <div v-show="shareTip.show" class="share-tip">
      <div v-if="shareTip.app" class="app-option-btn-tip"></div>
      <div v-if="shareTip.weChat" class="wechat-share-tip"></div>
    </div>
    <div v-show="!shareTip.weChat" class="popup-content" :class="poster.showContainer && 'full'">
      <div class="close-btn" @click="handleCloseBtnClick">
        <i class="icomoon-close-empty close-btn-icon"></i>
      </div>
      <div v-show="showShareBox" class="content-container share-box-container">
        <div class="container-head">
          <div class="company-logo-container">
            <img v-if="companyLogoPath" class="company-logo" :src="companyLogoPath"/>
          </div>
          <div class="company-info">
            <div class="company-name">{{ companyName }}</div>
          </div>
        </div>
        <div class="container-body">
          <template v-if="!hiddenReferShare">
            <div class="share-list-container">
              <div class="share-label">{{ $t('jobDetail.sendTo') }}</div>
              <div class="share-list">
                <div v-for="(line, index) in shareBoxLineList" class="share-line" :key="index">
                  <div
                    v-for="(child, childIndex) in line"
                    class="share"
                    :key="childIndex"
                    :class="`share-${child.name}`"
                    @click="handleShareBoxIconClick(child)"
                  ></div>
                </div>
              </div>
            </div>
            <div v-if="showLearnMore" class="learn-more">
              <a :href="$DjangoBaseUrl(`/referral/about-program/?company_id=${companyId}`)" target="_blank"> {{ $t('jobDetail.learnMore') }} ></a>
            </div>
          </template>
          <template v-if="hasPosterData">
            <van-divider v-if="!hiddenReferShare" class="poster-divider">{{ $t('jobDetail.or') }}</van-divider>
            <div v-if="loadingPosterData" class="poster-previewer-container">
              <RectLoading class="poster-data-loading" background="transparent" rectBackground="var(--custom-color)"/>
            </div>
            <div v-else class="poster-previewer-container">
              <div class="poster-share-tip">
                <span class="share-tip">{{ $t('jobDetail.tapToShare') }}</span>
                <span v-show="poster.isGeneratingVideo" class="video-tip">{{ $t('jobDetail.videoIsGenerating') }}</span>
              </div>
              <div class="poster-previewer-list">
                <div
                  v-for="(item, index) in previewPoster"
                  class="poster-previewer"
                  :key="index"
                  @click="handlePosterPreviewerClick(item)"
                >
                  <div class="poster-image-container">
                    <div class="disable-overlay"></div>
                    <div v-if="item.isVideo" class="play-video-icon">
                      <img src="@/assets/image/jobDetail/play.png"/>
                    </div>
                    <img :src="item.shareImagePath"/>
                  </div>
                  <div class="share-btn">
                    <i class="btn-icon el-icon-share"></i>
                    <span class="btn-label">{{ $t('jobDetail.sharePoster') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-show="qrCode.showContainer" class="content-container qr-code-container">
        <div class="container-head">{{ qrCode.title }}</div>
        <div class="container-body">
          <div v-if="qrCode.loading" class="qr-code-loading"></div>
          <div v-else class="qr-code" :style="qrCode.style"></div>
        </div>
      </div>
      <div v-if="companyHasJobPoster" v-show="poster.showContainer" class="content-container poster-container">
        <div class="container-head"></div>
        <div class="container-body">
          <RectLoading v-if="poster.loading" class="poster-loading" background="transparent" rectBackground="#fff"/>
          <div v-else class="poster-wrapper">
            <video
              v-if="currentPoster.isVideo"
              controls
              ref="poster-video"
              preload="auto"
              :src="currentPoster.originVideoSrc"
              :poster="currentPoster.shareImagePath"
              @loadedmetadata="onPosterVideoLoaded"
            ></video>
            <img v-else :src="posterImgUrl"/>
            <van-uploader
              v-if="currentPosterShowType === 'CUSTOM'"
              v-model="newJobPosterImages"
              :accept="currentPoster.poster_type === 'video' ? 'video/*' : 'image/*'"
              class="upload-new-poster"
              :preview-image="false"
              :before-read="beforeUploadPoster"
              :after-read="handleUploadPoster"
            >
              <div class="label">{{ $t(`${jobPosterI18nPrefix}.btn.${currentPoster.poster_type === 'video' ? 'editVideoJobPoster' : 'editImgJobPoster'}`) }}</div>
            </van-uploader>
          </div>
          <div v-if="!(currentPosterShowType === 'CUSTOM' || currentPosterShowType === 'INSTRUCTIONS')" v-show="poster.showSaveTip && !currentPoster.isVideo" class="save-video-tip-pop">
            <div class="save-video-text">{{ $t('jobDetail.longPressToSave') }}</div>
          </div>
          <div
            v-if="!(currentPosterShowType === 'CUSTOM' || currentPosterShowType === 'INSTRUCTIONS')"
            v-show="poster.showSaveTip && currentPoster.isVideo"
            class="save-video-tip-pop"
            @click="handlePosterSaveTipClick"
          >
            <div v-show="!poster.isGeneratingVideo">
              <div class="download-text">
                {{ $t('jobDetail.downloadNow') }}
              </div>
              <div class="download-image"><span class="iconfont icondownload"></span></div>
              <div class="save-video-text">{{ $t('jobDetail.saveVideo') }}</div>
            </div>
            <div v-show="poster.isGeneratingVideo">
              <div>{{ $t('jobDetail.loading') }}</div>
              <RectLoading class="generate-video-loading" background="transparent" rectBackground="#fff"/>
            </div>
          </div>
          <div v-show="false" class="save-tip-wrapper">
            <div v-if="currentPoster.isVideo" class="save-tip video" @click="handlePosterSaveTipClick">
              <template v-if="poster.isGeneratingVideo">
                <div class="loading-tip">{{ $t('jobDetail.loading') }}</div>
                <RectLoading class="generate-video-loading" background="transparent" rectBackground="#fff"/>
              </template>
              <template v-else>
                <div class="save-tip-label">{{ $t('jobDetail.downloadNow') }}</div>
                <div class="save-icon">
                  <i class="iconfont icondownload"></i>
                </div>
                <div class="share-tip save-tip-label">{{ $t('jobDetail.saveVideo') }}</div>
              </template>
            </div>
            <div v-else class="save-tip image save-tip-label">{{ $t('jobDetail.longPressToSave') }}</div>
          </div>
          <div class="bottom-poster-list">
            <van-tabs
              v-model="activePosterShowTypeIndex"
              class="poster-show-type-tabs"
              line-height="0px"
              title-inactive-color="#000000"
              animated
              @change="handleChangePosterShowType"
            >
              <van-tab
                v-for="(item, index) in posterShowTypes"
                :title="item.label"
                :key="index"
              >
                <template v-if="item.value === 'CUSTOM'" #title>
                  <van-icon name="plus" />
                </template>
                <div class="bottom-poster-list-content">
                  <div
                    v-for="(jobPoster, index) in getCurrentPosterList(item.value)"
                    :key="index"
                    :style="{ backgroundImage: `url(${jobPoster.shareImagePath})` }"
                    @click="changeCurrentPoster(jobPoster)"
                  >
                    <div v-if="item.value === 'AMBASSADOR_POSTER'" class="poster-item">
                      <div class="delete-poster">
                        <i class="el-icon-delete" @click="handleDeletePoster(jobPoster)"></i>
                      </div>
                      <div v-if="jobPoster.isVideo && jobPoster.ambassador_poster_id !== currentPoster.ambassador_poster_id" class="icon-video-play">
                        <div></div>
                        <img src="@/assets/image/jobDetail/play.png"/>
                      </div>
                      <span v-show="jobPoster.ambassador_poster_id === currentPoster.ambassador_poster_id" class="iconfont icontick-01"></span>
                    </div>
                    <div v-else class="poster-item">
                      <div v-if="jobPoster.isVideo && jobPoster.id !== currentPoster.id" class="icon-video-play">
                        <div></div>
                        <img src="@/assets/image/jobDetail/play.png"/>
                      </div>
                      <span v-show="jobPoster.id === currentPoster.id" class="iconfont icontick-01"></span>
                    </div>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
          <!-- <div class="poster-list-wrapper">
            <div class="poster-list">
              <div
                v-for="(item, index) in showJobPosterList"
                class="poster"
                :key="index"
                :style="{ backgroundImage: `url(${item.shareImagePath})` }"
                :class="currentPoster.id === item.id && 'is-active'"
                @click="handlePosterClick(item)"
              >
                <div v-if="item.isVideo" class="play-video-icon">
                  <img src="@/assets/image/jobDetail/play.png"/>
                </div>
                <div class="active-icon">
                  <i class="iconfont icontick-01"></i>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div v-show="showWeChatShareStep" class="content-container share-step-container">
        <div class="container-head">
          <ul class="share-step-list">
            <li class="share-step share-to">
              <div class="icon"></div>
              <span>{{ $t('jobDetail.shareToWechat') }}</span>
            </li>
            <li class="share-step step1">
              <div class="icon"></div>
              <span>{{ $t('jobDetail.holdToHighlight') }}</span>
            </li>
            <li class="share-step step2">
              <div class="icon"></div>
              <span>{{ $t('jobDetail.selectCopy') }}</span>
            </li>
            <li class="share-step step3">
              <div class="icon"></div>
              <span>{{ $t('jobDetail.openWeChatAndPaste') }}</span>
            </li>
          </ul>
        </div>
        <div class="container-body">
          <div class="tip-line">{{ $t('jobDetail.hereIsAJob') }}</div>
          <div class="tip-line job-info">
            <div class="job-name">{{ jobName }}</div>
            <div class="job-location">{{ locationName }}</div>
          </div>
          <div class="tip-line share-link">{{ shareLink }}</div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="copyLinkDialog.show"
      class="referral-url-dialog"
      :title="copyLinkDialog.title"
      :confirm-button-text="$t('common.btn.copy')"
      :message="copyLinkDialog.link"
      @cancel="handleCopyLinkDialogClose"
      @confirm="handleCopyLinkDialogConfirm"
    />
    <VueCanvasPoster
      v-if="poster.enablePainting"
      :widthPixels="1000"
      :painting="poster.painting"
      @success="onPosterPaintingFinished(true, $event)"
      @fail="onPosterPaintingFinished(false, $event)"
    />
    <VueQr
      v-if="poster.enableRenderQrCode"
      :bind-element="false"
      qid="posterQrCode"
      :logoSrc="poster.qrCodeLogo"
      :text="poster.qrCodeText"
      :size="200"
      :callback="onPosterQrCodeRendered"
    />
    <VueQr
      v-if="qrCode.enableRender"
      :bind-element="false"
      qid="shareQrCode"
      :logoSrc="qrCode.logo"
      :text="qrCode.link"
      :size="200"
      :callback="qrCode.onRendered"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { VueCanvasPoster } from 'vue-canvas-poster'
import VueQr from 'vue-qr'
import RectLoading from '@/components/loading/rectLoading.vue'
import { isEn } from '@/i18n'
import { deviceType, addQueryInPath, md5 } from '@/utils/common'
import { dataUrlToFile, getBindImageHeight, getFilePath, preCompressImage, resizeDataURL, uploadBase64Src, uploadFile } from '@/utils/qiniu'
import { DEFAULT_COMPANY_LOGO_PATH } from '@/constant/common'
import { ACCEPT_FILE_SIZE, ACCEPT_VIDEO_DURATION_SECONDS, ACCEPT_VIDEO_FILE_SIZE, JOB_POSTER_SHOW_TYPE } from '@/constant/jobPoster'
import { ROOT_COMPANY_ID } from '@/constant/company'

const DEFAULT_POSTER_SHARE_IMAGE = '@/assets/image/jobDetail/StuxShareImage.png'

export default {
  components: {
    VueCanvasPoster,
    VueQr,
    RectLoading
  },
  inject: ['getCustomFontFromTheme'],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isShareAllJobs: {
      type: Boolean,
      default: false
    },
    shareJobs: {
      type: Array,
      required: true
    },
    shareLink: {
      type: String,
      required: true
    },
    companyLogoPath: {
      type: String,
      required: true
    },
    companyId: {
      type: [String, Number],
      required: true
    },
    rootCompanyId: {
      type: [String, Number],
      required: true
    },
    companyName: {
      type: String,
      required: true
    },
    companyHasJobPoster: {
      type: Boolean,
      default: false
    },
    weChatShareMomentTitle: {
      type: String,
      required: true
    },
    onlyOneJob: {
      type: Boolean,
      default: false
    },
    isInChina: {
      type: Boolean,
      default: true
    },
    cityName: {
      required: true
    }
  },
  data () {
    return {
      jobPosterI18nPrefix: 'admin.company.jobPoster',
      showPopup: false,
      showShareBox: false,
      showWeChatShareStep: false,
      shareTip: {
        show: false,
        app: false,
        weChat: false
      },
      posterDataLoader: null,
      loadingPosterData: false,
      previewPoster: [],
      posterList: [],
      commonPosterList: [],
      customPosterList: [],
      instructionsPosterList: [],
      ambassadorPosterList: [],
      currentPosterShowType: 'COMMON',
      newJobPosterImages: [],
      isAmbassador: false,
      activePosterShowTypeIndex: 0,
      poster: {
        showContainer: false,
        showSaveTip: false,
        loading: false,
        isGeneratingVideo: false,
        enablePainting: false,
        painting: null,
        paintingPromise: null,
        paintingPromiseResolve: null,
        enableRenderQrCode: false,
        qrCodeLogo: null,
        qrCodeText: null,
        qrCodePromise: null,
        qrCodePromiseResolve: null,
        qrCodeImagePath: null
      },
      currentPoster: {
        isVideo: false
      },
      posterImgUrl: null,
      qrCode: {
        showContainer: false,
        enableRender: false,
        title: '',
        link: null,
        logo: null,
        onRendered: null,
        loading: false,
        style: null
      },
      qrCodeLogo: null,
      copyLinkDialog: {
        show: false,
        title: '',
        link: ''
      }
    }
  },
  computed: {
    hiddenReferShare () {
      return this.rootCompanyId === ROOT_COMPANY_ID.MERCEDES_BENZ
    },
    showLearnMore () {
      return this.rootCompanyId !== 4753
    },
    hasPosterData () {
      if (this.companyHasJobPoster) {
        return this.loadingPosterData || this.posterList.length > 0
      } else {
        return false
      }
    },
    showJobPosterList () {
      return _.filter(this.posterList, item => {
        if (!this.isAmbassador && item.show_type !== 'COMMON') {
          return false
        }
        return true
      })
    },
    posterShowTypes () {
      const list = [
        {
          label: this.$t(`${this.jobPosterI18nPrefix}.label.companyJobPoster`),
          value: 'COMMON',
          hidden: !this.commonPosterList.length
        },
        {
          label: this.$t(`${this.jobPosterI18nPrefix}.label.ambassadorJobPoster`),
          value: 'AMBASSADOR_POSTER',
          hidden: !this.isAmbassador || !this.ambassadorPosterList.length
        },
        {
          label: this.$t(`${this.jobPosterI18nPrefix}.label.customJobPoster`),
          value: 'CUSTOM',
          hidden: !this.isAmbassador || !this.customPosterList.length
        },
        {
          label: this.$t(`${this.jobPosterI18nPrefix}.label.instructionsJobPoster`),
          value: 'INSTRUCTIONS',
          hidden: !this.isAmbassador || !this.instructionsPosterList.length
        }
      ]
      return _.filter(list, item => !item.hidden)
    },
    jobName () {
      if (this.isShareAllJobs) {
        return this.$t('companyJobList.message.multipleJobs')
      } else {
        const firstJob = _.first(this.shareJobs)
        return this.shareJobs.length > 1 ? this.$t('companyJobList.message.multipleJobs') : (firstJob?.title || '')
      }
    },
    locationName () {
      let locationName = null
      if (this.cityName) {
        locationName = this.cityName
      } else if (this.isShareAllJobs) {
        locationName = this.$t('companyJobList.message.multipleLocations')
      } else {
        _.forEach(this.shareJobs, job => {
          if (job.cities?.length > 1) {
            locationName = this.$t('companyJobList.message.multipleLocations')
            return false
          }
          const jobLocationName = job.city_name || _.first(job.cities)
          if (!locationName) {
            locationName = jobLocationName
          } else if (jobLocationName && locationName !== jobLocationName) {
            locationName = this.$t('companyJobList.message.multipleLocations')
            return false
          }
        })
      }
      return locationName || ''
    },
    shareBoxLineList () {
      const qqParams = {
        url: this.shareLink,
        desc: '',
        title: this.companyName,
        summary: this.jobName,
        pics: this.completeCompanyLogoPath,
        site: 'Ajinga'
      }
      const inLine = [
        {
          name: 'qrcode',
          action: this.shareToQrCode
        },
        {
          name: 'qq',
          path: 'http://connect.qq.com/widget/shareqq/index.html',
          params: qqParams
        },
        {
          name: 'qzone',
          shareCount: 'qzone',
          path: 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey',
          params: qqParams
        },
        {
          name: 'sina',
          shareCount: 'sinaminiblog',
          path: 'http://service.weibo.com/share/share.php',
          params: {
            url: this.shareLink,
            pic: this.completeCompanyLogoPath,
            title: this.weChatShareMomentTitle
          }
        },
        {
          name: 'wechat',
          shareCount: 'wechat',
          action: this.shareToWeChat
        }
      ]
      const outLine = [
        {
          name: 'facebook',
          shareCount: 'facebook',
          path: 'https://m.facebook.com/sharer.php',
          params: {
            u: this.shareLink
          }
        },
        {
          name: 'messenger',
          path: 'fb-messenger://share/',
          params: {
            link: this.shareLink
          }
        },
        {
          name: 'linkedin',
          shareCount: 'linkedin',
          path: 'http://www.linkedin.com/shareArticle',
          params: {
            mini: true,
            url: this.shareLink
          }
        },
        {
          name: 'whatsapp',
          shareCount: 'whatsapp',
          path: 'whatsapp://send',
          params: {
            text: this.shareLink + `\n\n${this.weChatShareMomentTitle}`
          }
        },
        {
          name: 'email',
          action: this.shareToEmail
        }
      ]
      const lineList = [inLine, outLine]
      if (!this.isInChina) {
        lineList.reverse()
      }
      return lineList
    },
    completeCompanyLogoPath () {
      if (this.companyLogoPath.includes('http')) {
        return this.companyLogoPath
      } else {
        return this.$DjangoBaseUrl(this.companyLogoPath)
      }
    },
    shortUniqueId () {
      return _.get(this.shareJobs, '0.short_unique_id')
    }
  },
  created () {
    this.loadPosterData()
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount', 'getCurrentSoftUser']),
    ...mapActions('common', ['getMediaInfo', 'watermarkVideo', 'getMediaPrefopStatus', 'batchDeletePosterImage']),
    ...mapActions('job', ['getJobDetailJobPoster']),
    ...mapActions('jobPosterAmbassador', ['checkAccountIsAmbassador', 'uploadAmbassadorJobPoster', 'deleteAmbassadorJobPoster']),
    async checkCurrentAccountIsAmbassador () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.checkAccountIsAmbassador({ job_short_id: this.shortUniqueId })
        this.isAmbassador = resp
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleChangePosterShowType () {
      this.currentPosterShowType = this.posterShowTypes[this.activePosterShowTypeIndex].value
      const posterList = this.getCurrentPosterList(this.currentPosterShowType)
      if (!posterList.length) {
        return
      }
      this.changeCurrentPoster(posterList[0])
    },
    addJobPosterByShowType (showType, jobPoster) {
      if (showType === JOB_POSTER_SHOW_TYPE.COMMON) {
        this.commonPosterList.push(jobPoster)
      } else if (showType === JOB_POSTER_SHOW_TYPE.CUSTOM) {
        this.customPosterList.push(jobPoster)
      } else if (showType === JOB_POSTER_SHOW_TYPE.INSTRUCTIONS) {
        this.instructionsPosterList.push(jobPoster)
      } else {
        this.ambassadorPosterList.push(jobPoster)
      }
    },
    getCurrentPosterList (showType) {
      if (showType === JOB_POSTER_SHOW_TYPE.COMMON) {
        return this.commonPosterList
      } else if (showType === JOB_POSTER_SHOW_TYPE.CUSTOM) {
        return this.customPosterList
      } else if (showType === JOB_POSTER_SHOW_TYPE.INSTRUCTIONS) {
        return this.instructionsPosterList
      } else {
        return this.ambassadorPosterList
      }
    },
    async changeCurrentPoster (jobPoster) {
      // 正在生成图片时不可切换
      if (this.isGeneratingBgImagePosterId) {
        return
      }
      if (jobPoster.id === this.currentPoster.id && this.currentPoster.ambassador_poster_id === jobPoster.ambassador_poster_id && this.showPopup) {
        return
      }
      this.currentPoster = jobPoster
      if (jobPoster.bgImageSrc && !jobPoster.isVideo) {
        this.posterImgUrl = jobPoster.bgImageSrc
        return
      }
      this.handlePosterClick(jobPoster)
    },
    async handleUploadPoster (fileInfo) {
      const file = fileInfo.file
      const fileType = file.type
      const language = this.languageCode === 'en' ? 'en' : 'cn'
      const fileKey = `ambassador-poster/${this.companyId}/${language}/${fileType}/${new Date().valueOf()}`
      this.$eventBus.$emit('showLoading', true)
      this.showPopup = false
      try {
        const resp = await uploadFile(file, fileKey)
        if (resp) {
          this.fileKey = resp.key
          const posterInfo = {
            company_id: this.companyId,
            job_poster_id: this.currentPoster.id,
            poster_url: fileKey
          }
          await this.uploadAmbassadorJobPoster(posterInfo)
          this.newJobPosterImages = []
          await this.loadPosterData()
        }
      } finally {
        this.activePosterShowTypeIndex = 1
        this.handleChangePosterShowType()
        this.showPopup = true
        this.$eventBus.$emit('showLoading', false)
      }
    },
    beforeUploadPoster (file) {
      const canUploadFileType = this.currentPoster.poster_type
      const fileType = file.type
      let msg = null

      if (/image/.test(fileType)) {
        if (file.size > ACCEPT_FILE_SIZE) {
          msg = this.$t(`${this.jobPosterI18nPrefix}.message.wrongImageSize`, { size: ACCEPT_FILE_SIZE / (1024 * 1024) })
        }
      } else if (/video/.test(fileType)) {
        const url = URL.createObjectURL(file)
        const audioElement = new Audio(url)
        audioElement.addEventListener('loadedmetadata', () => {
          this.newVideoJobPosterDuration = parseInt(audioElement.duration)
        })
        if (file.size > ACCEPT_VIDEO_FILE_SIZE || this.newVideoJobPosterDuration > ACCEPT_VIDEO_DURATION_SECONDS) {
          msg = this.$t(`${this.jobPosterI18nPrefix}.message.wrongVideoSize`, { size: ACCEPT_VIDEO_FILE_SIZE / (1024 * 1024), duration: ACCEPT_VIDEO_DURATION_SECONDS })
        }
      } else {
        msg = canUploadFileType === 'img' ? this.$t(`${this.jobPosterI18nPrefix}.message.wrongImageType`) : this.$t(`${this.jobPosterI18nPrefix}.message.wrongVideoType`)
      }

      if (msg) {
        this.$message.info({
          message: msg,
          customClass: 'message-override'
        })
        return false
      }

      return true
    },
    async handleDeletePoster (jobPoster) {
      if (!jobPoster.ambassador_poster_id) {
        return
      }
      this.showPopup = false
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.deleteAmbassadorJobPoster({ companyId: this.companyId, ambassadorPosterId: jobPoster.ambassador_poster_id })
        let msg = ''
        if (resp) {
          msg = `${this.jobPosterI18nPrefix}.message.deleteAmbassadorPosterSuccess`
        } else {
          msg = `${this.jobPosterI18nPrefix}.message.deleteAmbassadorPosterFail`
        }
        this.$message.info({
          message: this.$t(msg),
          customClass: 'message-override'
        })
      } finally {
        await this.loadPosterData()
        const posterList = this.getCurrentPosterList(this.currentPosterShowType)
        if (posterList.length) {
          this.showPopup = true
          this.changeCurrentPoster(posterList[0])
        }
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async getQrCodeLogo () {
      if (this.qrCodeLogo) {
        return this.qrCodeLogo
      }
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          this.qrCodeLogo = this.companyLogoPath
          resolve(this.qrCodeLogo)
        }
        img.onerror = () => {
          if (process.env.VUE_APP_ENV === 'development') {
            this.qrCodeLogo = require('@/assets/image/jobDetail/blank-logo.png')
          } else {
            this.qrCodeLogo = this.$DjangoBaseUrl(DEFAULT_COMPANY_LOGO_PATH)
          }
          resolve(this.qrCodeLogo)
        }
        img.src = this.companyLogoPath
      })
    },
    async loadPosterData () {
      if (!this.companyHasJobPoster) {
        return
      }
      this.loadingPosterData = true
      if (this.posterDataLoader) {
        await this.posterDataLoader
        this.posterDataLoader = null
        this.loadingPosterData = false
        return
      }
      this.posterDataLoader = this.getJobDetailJobPoster({ company_id: this.companyId, language_code: isEn() ? 'en' : 'cn' }).then(resp => {
        const previewPoster = {}
        this.posterList = []
        this.commonPosterList = []
        this.customPosterList = []
        this.instructionsPosterList = []
        this.ambassadorPosterList = []
        const posterList = _.map(resp.job_poster_list, posterData => {
          posterData.isVideo = posterData.poster_type === 'video'
          posterData.bgSize = JSON.parse(posterData.bg_size)
          posterData.contentConfig = JSON.parse(posterData.content_configuration)
          posterData.qrCodeConfig = JSON.parse(posterData.qrcode_configuration)
          posterData.shareImagePath = this.getPosterShareImagePath(posterData)
          if (posterData.isVideo) {
            posterData.originVideoSrc = this.getPosterFilePath(posterData.bg_source_url)
          }
          if (!previewPoster.image && !posterData.isVideo) {
            previewPoster.image = posterData
          }
          if (!previewPoster.video && posterData.isVideo) {
            previewPoster.video = posterData
          }
          this.addJobPosterByShowType(posterData.show_type, posterData)
          return posterData
        })
        this.posterList = posterList
        this.previewPoster = previewPoster
      })
      await this.posterDataLoader
      this.posterDataLoader = null
      this.loadingPosterData = false
    },
    generateVideoPosterUniqueKey (posterData) {
      const allInfo = {
        bgSourceUrl: posterData.bg_source_url,
        bgSize: posterData.BgSize,
        contentConfig: posterData.contentConfig,
        qrCodeConfig: posterData.qrCodeConfig,
        shareLink: this.shareLink,
        watermarkBgLocation: posterData.watermark_bg_location,
        watermarkBgUrl: posterData.watermark_bg_url,
        jobName: this.jobName,
        locationName: this.locationName,
        companyId: this.companyId,
        isShareAllJobs: this.isShareAllJobs,
        shareJobs: _.map(this.shareJobs, job => job.id || job.pk)
      }
      return md5(JSON.stringify(allInfo))
    },
    getPosterFilePath (fileKey) {
      const filePath = getFilePath(fileKey)
      return addQueryInPath(filePath, { v: new Date().getTime() })
    },
    getPosterShareImagePath (posterData) {
      const imagePath = posterData?.share_img_url
      if (imagePath) {
        return this.getPosterFilePath(imagePath)
      } else {
        return DEFAULT_POSTER_SHARE_IMAGE
      }
    },
    async shareToWeChat () {
      this.showShareBox = false
      if (deviceType.isWeChat || deviceType.isJW) {
        await this.$nextTick()
        this.shareTip.show = true
        this.shareTip.app = false
        this.shareTip.weChat = true
        setTimeout(() => {
          this.shareTip.show = false
          this.shareTip.weChat = false
          this.$emit('update:show', false)
        }, 3500)
      } else {
        this.showWeChatShareStep = true
      }
    },
    async shareToQrCode () {
      this.showShareBox = false
      this.qrCode.showContainer = true
      this.qrCode.loading = true
      this.qrCode.title = this.companyName
      this.qrCode.link = this.shareLink
      this.qrCode.logo = await this.getQrCodeLogo()
      this.qrCode.onRendered = (qrCodeImagePath) => {
        this.qrCode.enableRender = false
        this.qrCode.style = { backgroundImage: `url(${qrCodeImagePath})` }
        this.qrCode.loading = false
      }
      this.qrCode.enableRender = true
    },
    shareToEmail () {
      if (deviceType.isWeChat) {
        this.copyLinkDialog.title = this.$t('jobDetail.msg.copyUrl')
        this.copyLinkDialog.link = this.shareLink
        this.showShareBox = false
        this.copyLinkDialog.show = true
      } else {
        window.location.href = `mailto:?body=${this.shareLink}`
      }
    },
    addShareCount (site) {
      // share count not support on job list
    },
    handleCopyLinkDialogClose () {
      this.showShareBox = true
      this.copyLinkDialog = false
    },
    async handleCopyLinkDialogConfirm () {
      let isSuccess = false
      try {
        await this.$copyText(this.copyLinkDialog.link)
        isSuccess = true
      } catch {
        isSuccess = false
      }
      const messageI18nKey = isSuccess ? 'copySuccess' : 'copyFail'
      const message = this.$t(`jobDetail.message.${messageI18nKey}`)
      this.$toast({ message, position: 'bottom' })
      await this.$nextTick()
      if (isSuccess) {
        this.showShareBox = true
        this.copyLinkDialog.show = false
      } else {
        this.showShareBox = false
        this.copyLinkDialog.show = true
      }
    },
    handlePosterTextOverflow (contentCss, text, fontFamily, maxLines, suffix) {
      if (!text) {
        return [text]
      }
      if (!suffix) {
        suffix = ''
      }
      if (!contentCss.MaxWidth) {
        return [text + suffix]
      }
      const el = document.createElement('div')
      el.style.visibility = 'hidden'
      el.style.fontSize = `${contentCss.size || 0}px`
      el.style.fontFamily = fontFamily
      el.style.fontWeight = contentCss.fontBold ? 'bold' : null
      el.style.width = `${contentCss.MaxWidth || 0}px`
      document.body.appendChild(el)
      el.innerHTML = text[0]
      let height = el.clientHeight
      el.innerHTML = ''
      const lines = []
      let line = ''
      const overFlowSuffix = suffix === '...' ? '' : suffix
      _.forEach(text, char => {
        let nowText = el.innerHTML
        el.innerHTML += char
        if (el.clientHeight > height) {
          if (lines.length < (maxLines - 1)) {
            lines.push(line)
            line = ''
          } else {
            el.innerHTML = nowText + '...' + overFlowSuffix
            while (el.clientHeight > height) {
              nowText = nowText.slice(0, -1)
              line = line.slice(0, -1)
              el.innerHTML = nowText + '...' + overFlowSuffix
            }
            lines.push(line + '...' + overFlowSuffix)
            line = ''
            return false
          }
          height = el.clientHeight
        } else {
          line += char
        }
      })
      if (line) {
        el.innerHTML += suffix
        if (el.clientHeight > height) {
          let nowText = el.innerHTML
          el.innerHTML = nowText + '...' + overFlowSuffix
          while (el.clientHeight > height) {
            nowText = nowText.slice(0, -1)
            line = line.slice(0, -1)
            el.innerHTML = nowText + '...' + overFlowSuffix
          }
          lines.push(line + '...' + overFlowSuffix)
        } else {
          lines.push(line + suffix)
        }
      }
      el.remove()
      return lines
    },
    async initPosterVideoInfo (posterData) {
      const videoInfo = {}
      try {
        const resp = await this.getMediaInfo(posterData.bg_source_url)
        if (resp?.streams.length > 0) {
          const info = resp.streams[0]
          const width = info.width
          const height = info.height
          posterData.videoInfo = {
            width,
            height,
            displayAspectRatio: info.display_aspect_ratio || `${width}/${height}`
          }
        }
      } finally {
        posterData.videoInfo = videoInfo
      }
    },
    async renderPosterImage (posterData) {
      if (posterData.qrcode_configuration.haveLogo) {
        this.poster.qrCodeLogo = await this.getQrCodeLogo()
      }
      this.poster.qrCodeText = this.shareLink
      this.poster.qrCodePromise = new Promise((resolve, reject) => {
        this.poster.qrCodePromiseResolve = resolve
        this.poster.enableRenderQrCode = true
      })
      this.poster.paintingPromise = new Promise((resolve, reject) => {
        this.poster.paintingPromiseResolve = resolve
        const bgImagePath = posterData.isVideo ? posterData.watermark_bg_url : posterData.bg_source_url
        const painting = {
          width: `${posterData.bgSize.X || 1}px`,
          height: `${posterData.bgSize.Y || 1}px`,
          background: this.getPosterFilePath(bgImagePath),
          views: []
        }
        posterData.contentConfig.forEach(item => {
          let fontFamily = item.data.font
          if (item.data.customFont) {
            /**
               *  vue-canvas-poster组件中的fontFamily的值只支持设置单个
               *  去除自定义字体前后的 " 使该组件支持多个fontFamily
               *  例如： vue-canvas-poster组件中fontFamily的应用为 font: 12px "{fontFamily}"
               *      若 fontFamily = "宋体", "Arial", "sans-serif" 则 => font: 12px ""宋体", "Arial", "sans-serif"" 不符合规则
               */
            fontFamily = this.getCustomFontFromTheme()?.slice(1, -1)
          }
          if (item.data.status) {
            const baseCss = {
              left: `${item.data.X || 0}px`,
              top: `${item.data.Y || 0}px`,
              fontSize: `${item.data.size || 0}px`,
              lineHeight: `${(item.data.size || 0) + 6}px`,
              fontFamily: fontFamily,
              fontWeight: item.data.fontBold,
              width: `${item.data.MaxWidth || 0}px`,
              color: item.data.color,
              textAlign: item.data.centerAlign ? 'center' : 'left',
              maxLines: 2
            }
            const viewItem = {
              type: 'text',
              text: '',
              css: { ...baseCss }
            }
            if (item.name === 'jobName') {
              const text = this.jobName
              const textLines = this.handlePosterTextOverflow(item.data, text, fontFamily)
              if (textLines.length > 1) {
                _.forEach(textLines, line => {
                  painting.views.push({
                    type: 'text',
                    text: line,
                    css: {
                      ...baseCss,
                      textAlign: null,
                      maxLines: 1
                    }
                  })
                })
              } else {
                viewItem.css.maxLines = 2
                viewItem.text = textLines[0] || text
                painting.views.push(viewItem)
              }
            } else if (item.name === 'city') {
              viewItem.text = this.locationName
              viewItem.css.maxLines = 1
              painting.views.push(viewItem)
            } else if (item.name === 'companyName') {
              viewItem.css.maxLines = 1
              viewItem.text = this.companyName
              painting.views.push(viewItem)
            }
          }
        })

        // add qrCode
        const qrCodeConfig = posterData.qrCodeConfig
        return this.poster.qrCodePromise.then(() => {
          const qrCodeView = {
            type: 'image',
            url: this.poster.qrCodeImagePath,
            css: {
              width: `${qrCodeConfig.width || 0}px`,
              height: `${qrCodeConfig.width || 0}px`, // config only has width, qrCode is a square
              left: `${qrCodeConfig.X || 0}px`,
              top: `${qrCodeConfig.Y || 0}px`,
              borderRadius: null
            }
          }
          if (qrCodeConfig.roundedCorners) {
            qrCodeView.css.borderRadius = `${parseFloat(qrCodeConfig.width || 0) * 0.05}px`
          }
          painting.views.push(qrCodeView)
          this.poster.painting = painting
          this.poster.enablePainting = true
        })
      })
      await Promise.all([this.poster.qrCodePromise, this.poster.paintingPromiseResolve])
    },
    async renderPoster () {
      const posterData = this.currentPoster
      if (!posterData) {
        return
      }
      this.poster.loading = true
      if (posterData.isVideo) {
        if (!posterData.videoInfo) {
          await this.initPosterVideoInfo(posterData)
        }
        if (!posterData.videoKeyAfterCompound) {
          this.poster.isGeneratingVideo = true
        }
      }

      let bgImage = posterData.bgImageSrc
      if (!bgImage) {
        await this.renderPosterImage(posterData)
        bgImage = posterData.bgImageSrc
      }

      if (!posterData.isVideo) {
        // if (deviceType.isJW) {
        //   const jw = await getJW()
        //   // 仅图片预览与下载，视频预览下载逻辑在生成视频后处理
        //   const fileKey = generateJobListPosterFileKey(this.companyId)
        //   await uploadBase64Src(fileKey, bgImage)
        //   const posterImgPath = getFilePath(fileKey)

        //   jw.previewImages({
        //     current: posterImgPath,
        //     urls: [posterImgPath],
        //     enableSave: 1,
        //     enableShare: 1
        //   })
        // }
        this.posterImgUrl = bgImage
      }
      this.poster.showSaveTip = true
      this.poster.loading = false
    },
    createVideoImageFileKey () {
      const language = 'en'
      const type = 'uservideoimage'
      const account = this.getCurrentAccount()
      const softUser = this.getCurrentSoftUser()
      const accountId = account?.id || softUser?.id || `noaccount${parseInt(Math.random() * 1000)}`
      return `job-poster/${this.companyId}-${accountId}-${language}-${type}-${new Date().valueOf()}`
    },
    async compoundPosterVideo (bgImagePath) {
      const posterData = this.currentPoster
      const videoFileKey = posterData.bg_source_url
      if (!videoFileKey) {
        return
      }
      const imageFileKey = this.createVideoImageFileKey()
      const imageWidth = posterData.bgSize.X
      const imageHeight = posterData.bgSize.Y
      const videoPosterType = posterData.watermark_bg_location
      const videoInfo = posterData.videoInfo
      if (videoPosterType === 'tail') {
        const displayAspectRatio = videoInfo.displayAspectRatio
        const aspectHeight = getBindImageHeight(displayAspectRatio, imageWidth, imageHeight)
        const resizeSrcFile = await dataUrlToFile(bgImagePath, 'test')
        // 压缩预处理图片，否则图片拼接视频不成功
        const blob = await preCompressImage(resizeSrcFile, imageWidth, aspectHeight)
        await uploadFile(blob, imageFileKey)
      } else {
        const resizeSrc = await resizeDataURL(bgImagePath, imageWidth, imageHeight)
        await uploadBase64Src(imageFileKey, resizeSrc)
      }
      // 调后台接口, 传imageFileKey, videoFileKey, videoPosterType, 后台调七牛接口合成视频, 将合成后的视频url传给前台并显示。
      const posterUniqueKey = this.generateVideoPosterUniqueKey(posterData)
      const params = {
        imageKey: imageFileKey,
        videoKey: videoFileKey,
        resolution: videoInfo,
        location: videoPosterType,
        posterUniqueKey
      }
      const { persistentId, lastUrl } = await this.watermarkVideo(params)
      if (persistentId) {
        _.delay(this.getCompoundPosterVideoStatus, 2000, persistentId, imageFileKey, posterUniqueKey)
      } else if (lastUrl) {
        posterData.videoKeyAfterCompound = lastUrl
        this.poster.isGeneratingVideo = false
      }
    },
    async getCompoundPosterVideoStatus (persistentId, imageFileKey, posterUniqueKey) {
      const posterData = this.currentPoster
      const resp = await this.getMediaPrefopStatus({
        persistentId,
        posterUniqueKey
      })
      if (resp.code > 2) {
        this.$message({
          type: 'error',
          showClose: true,
          message: this.$t('admin.company.jobPoster.message.operateFailed')
        })
        this.poster.isGeneratingVideo = false
        return
      }
      if (resp.code !== 0) {
        _.delay(this.getCompoundPosterVideoStatus, 2000, persistentId, imageFileKey, posterUniqueKey)
      } else if (resp?.items.length > 0) {
        const newVideoKey = resp.items[0].key
        posterData.videoKeyAfterCompound = newVideoKey
        this.poster.isGeneratingVideo = false
        imageFileKey && this.batchDeletePosterImage({ invalid_keys: [imageFileKey] })
      }
    },
    resetPosterData () {
      _.forEach(this.posterList, posterData => {
        posterData.videoKeyAfterCompound = null
        posterData.bgImageSrc = null
      })
    },
    onPosterPaintingFinished (isSuccess, $event) {
      const poster = this.poster
      poster.enablePainting = false
      if (!isSuccess) {
        // eslint-disable-next-line no-console
        console.error($event)
        return
      }
      const posterData = this.currentPoster
      // 合成后的图片，不论是图片海报的还是视频海报需要的图片都存起来
      const bgImage = posterData.bgImageSrc = $event
      if (poster.paintingPromise && poster.paintingPromiseResolve) {
        poster.paintingPromiseResolve(bgImage)
      }
      if (poster.isGeneratingVideo && posterData.isVideo) {
        this.$message.info({
          message: this.$t('jobDetail.videoIsGenerating'),
          customClass: 'message-override'
        })
        this.compoundPosterVideo(bgImage)
      } else {
        this.posterImgUrl = bgImage
      }
    },
    onPosterQrCodeRendered (qrCodeImagePath) {
      const poster = this.poster
      poster.enableRenderQrCode = false
      poster.qrCodeImagePath = qrCodeImagePath
      if (poster.qrCodePromise && poster.qrCodePromiseResolve) {
        poster.qrCodePromiseResolve(qrCodeImagePath)
      }
    },
    handleShareBoxIconClick (shareBoxItem) {
      this.addShareCount(shareBoxItem.shareCount)
      if (shareBoxItem.action) {
        shareBoxItem.action()
      } else {
        const shareLink = addQueryInPath(shareBoxItem.path, shareBoxItem.params)
        if (!shareLink.startsWith('http') && deviceType.isWeChat) {
          alert(this.$t('jobDetail.msg.openInBrowser'))
          return
        }
        window.open(shareLink)
      }
    },
    handleCloseBtnClick () {
      if (this.showShareBox) {
        this.$emit('update:show', false)
      } else if (this.qrCode.showContainer) {
        this.qrCode.showContainer = false
        this.showShareBox = true
      } else if (this.showWeChatShareStep) {
        this.showWeChatShareStep = false
        this.showShareBox = true
      } else if (this.poster.showContainer) {
        this.poster.showContainer = false
        this.poster.loading = true
        this.showShareBox = true
      } else {
        this.$emit('update:show', false)
      }
    },
    handlePosterPreviewerClick (posterData) {
      this.showShareBox = false
      this.shareTip.show = false
      this.poster.showContainer = true
      this.currentPoster = posterData
      this.renderPoster()
    },
    onPosterVideoLoaded () {

    },
    async handlePosterSaveTipClick () {
      const poster = this.poster
      const posterData = this.currentPoster
      if (poster.isGeneratingVideo || !posterData.videoKeyAfterCompound) {
        this.$message.info({
          message: this.$t('jobDetail.videoIsGenerating'),
          customClass: 'message-override'
        })
        return
      }

      const videoFileKey = posterData.videoKeyAfterCompound
      if (deviceType.isWeChat) {
        this.$router.push(`/recruiting/resource-download?type=video&key=${videoFileKey}&source=VIDEO_POSTER`)
        return
      }

      const videoPath = this.getPosterFilePath(videoFileKey)
      // if (deviceType.isJW) {
      //   const jw = await getJW()
      //   jw.downloadVideo({ video_url: videoPath }, { success () { }, fail () { } })
      // } else {
      // }
      window.location.href = `${videoPath}&attname=${new Date().getTime()}.mp4`
    },
    handlePosterClick (posterData) {
      if (this.poster.loading) {
        return
      }
      this.currentPoster = posterData
      this.activePosterShowTypeIndex = _.findIndex(this.posterShowTypes, showType => showType.value === posterData.show_type)
      this.renderPoster()
    }
  },
  watch: {
    show () {
      this.showPopup = this.show
      this.showShareBox = true
      if (this.show) {
        this.resetPosterData()
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = null
      }
      if (this.shortUniqueId) {
        this.checkCurrentAccountIsAmbassador()
      }
    },
    showShareBox () {
      if (this.showShareBox && (deviceType.isWeChat || deviceType.isJW)) {
        this.shareTip.show = true
        this.shareTip.app = true
        this.shareTip.weChat = false
      } else {
        this.shareTip.show = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.job-list-share-popup {
  overflow: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 200;

  .popup-mask {
    width: 100%;
    height: 100%;
    opacity: .75;
    background: #000;
    position: fixed;
    top: 0;
    left: 0;
  }

  .share-tip {
    .app-option-btn-tip {
      width: 266px;
      height: 64px;
      background-image: url($baseDomain + 'static/image/mobile_web/wechat-share-chinese.png');
      background-repeat: no-repeat;
      background-size: 100%;
      position: fixed;
      top: 10px;
      right: 74px;
      z-index: 100;
    }

    .wechat-share-tip {
      width: 100%;
      max-width: 380px;
      height: 100%;
      background: url($baseDomain + 'static/image/mobile_web/WeChat-Share-White-zh.png') no-repeat transparent;
      background-size: 100%;
      position: fixed;
      top: 0;
      right: 28px;
      z-index: 100;
    }
  }

  .popup-content {
    width: 90%;
    margin: 50vh auto 15px;
    margin: 50dvh auto 15px;
    transform: translateY(-50%);
    box-sizing: border-box;
    position: relative;

    &.full {
      width: 100%;
      height: 100%;
      margin: 0;
      transform: none;

      .close-btn {
        top: 2vw;
        right: 2vw;
      }
    }

    .close-btn {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      box-shadow: 0 1px 3px #030303;
      background: var(--custom-color);
      line-height: 1;
      font-size: 30px;
      color: #fff;
      position: absolute;
      top: -12px;
      right: -12px;
      z-index: 1;
    }

    .content-container {
      background: #fff;

      .container-head {
        margin-bottom: 15px;
        padding: 15px;
        background-color: var(--custom-color);
        color: #fff;
        box-sizing: border-box;
      }

      .container-body {
        padding: 10px 15px 25px;
      }
    }

    .share-box-container {
      .container-head {
        display: flex;
        align-items: center;

        .company-logo-container {
          .company-logo {
            width: 75px;
            height: 75px;
            border-radius: 50%;
          }
        }

        .company-info {
          margin-left: 15px;

          .company-name {
            font-size: 18px;
          }
        }
      }

      .container-body {
        .share-list-container {
          .share-list {
            padding-left: 50px;
            padding-right: 40px;

            .share-line {
              display: flex;
              margin-bottom: 10px;
              justify-content: space-between;
              align-items: center;

              .share {
                width: 30px;
                height: 30px;
                background-size: 100%;
                background-repeat: no-repeat;
                background-position: center;
              }

              .share-qrcode {
                background-image: url($baseDomain + 'static/image/mobile_web/icon_qrcode.png');
              }

              .share-qq {
                background-image: url($baseDomain + 'static/image/mobile_web/icon_qq.png');
              }

              .share-qzone {
                background-image: url($baseDomain + 'static/image/mobile_web/icon_qzone.ico');
              }

              .share-email {
                background-image: url($baseDomain + 'static/image/mobile_web/icon-email.png');
              }

              .share-renren {
                background-image: url($baseDomain + 'static/image/mobile_web/icon_renren.png');
              }

              .share-sina {
                background-image: url($baseDomain + 'static/image/mobile_web/icon_sina.png');
              }

              .share-wechat {
                background-image: url($baseDomain + 'static/image/mobile_web/icon_wechat.png');
              }

              .share-facebook {
                background-image: url($baseDomain + 'static/images_en/website-share/facebook.png');
              }

              .share-messenger {
                background-image: url($baseDomain + 'static/images_en/website-share/messenger.png');
              }

              .share-linkedin {
                background-image: url($baseDomain + 'static/images_en/website-share/linkedin.png');
              }

              .share-whatsapp {
                background-image: url($baseDomain + 'static/images_en/website-share/whatsapp.png');
                background-size: 37px;
              }
            }
          }
        }

        .learn-more {
          margin-top: 15px;
          text-align: right;
        }

        .poster-divider {
          margin: 5px 0;
          border-color: #000;
        }

        .poster-previewer-container {
          min-height: 50px;
          position: relative;

          .poster-data-loading {
            position: absolute;
          }

          .poster-share-tip {
            margin: 10px 0;
          }

          .poster-previewer-list {
            display: flex;
            justify-content: space-around;
            align-items: center;
            overflow: hidden;

            .poster-previewer {
              display: flex;
              width: 45%;
              height: 190px;
              padding-bottom: 40px;
              justify-content: space-around;
              align-items: center;
              flex-direction: column;
              box-sizing: border-box;
              position: relative;

              .poster-image-container {
                position: relative;

                .play-video-icon {
                  width: 35px;
                  height: 35px;
                  border-radius: 50%;
                  background: rgba($color: #000000, $alpha: 0.6);
                  transform: translate(-50%, -50%);
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  z-index: 1;

                  img {
                    width: 100%;
                  }
                }

                img {
                  max-width: 100%;
                  max-height: 150px;
                  border-radius: 8px;
                  object-fit: contain;
                }

                .disable-overlay {
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  left: 0;
                  z-index: 2;
                }
              }

              .share-btn {
                padding: 3px 10px;
                border-radius: 10px;
                font-size: 12px;
                background-color: var(--custom-color);
                color: #fff;
                position: absolute;
                bottom: 10px;

                .btn-icon {
                  margin-right: 2px;
                  vertical-align: middle;
                }

                .btn-label {
                  vertical-align: middle;
                }
              }
            }
          }
        }
      }
    }

    .share-step-container {
      .container-head {
        padding-bottom: 0;
      }

      .share-step-list {
        padding-left: 15px;
        padding-bottom: 10px;
        border-left: 1px solid #fff;
        position: relative;

        .share-step {
          margin-bottom: 10px;

          > * {
            vertical-align: middle;
          }

          .icon {
            width: 14px;
            height: 14px;
            background-size: 100%;
            background-position: center;
            background-repeat: no-repeat;
            position: absolute;
            left: -8px;
          }

          &.share-to {
            font-size: 16px;
            font-weight: bold;

            .icon {
              width: 20px;
              height: 20px;
              background-image: url($baseDomain + 'static/image/mobile_web/logo_share.png');
              left: -10px;
            }
          }

          &.step1 {
            .icon {
              background-image: url($baseDomain + 'static/image/mobile_web/step1.png');
            }
          }

          &.step2 {
            .icon {
              background-image: url($baseDomain + 'static/image/mobile_web/step2.png');
            }
          }

          &.step3 {
            .icon {
              background-image: url($baseDomain + 'static/image/mobile_web/step3.png');
            }
          }
        }

      }
    }

    .qr-code-container {
      .container-head {
        font-size: 16px;
        font-weight: bold;
      }

      .container-body {
        width: 260px;
        height: 260px;
        margin: 0 auto;

        >

        .qr-code-loading {
          height: 100%;
          background: url($baseDomain + 'static/images_en/loading_mid_.gif') no-repeat;
          background-position: center;
          background-size: 40px;
        }

        .qr-code {
          height: 100%;
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100%;
        }
      }
    }

    .poster-container {
      height: 100%;
      padding-top: 5vw;
      box-sizing: border-box;
      background: initial;

      .container-head {
        display: none;
      }

      .container-body {
        height: 100%;
        padding: 0;
        position: relative;

        .poster-wrapper {
          width: 90%;
          max-height: 68%;
          margin: 0 auto;
          overflow: auto;
          position: relative;

          img {
            width: 100%;
          }

          video {
            width: 100%;
            object-fit: cover;
          }

          .upload-new-poster {
            position: absolute;
            bottom: 16px;
            right: 32px;
            display: inline-block;
            vertical-align: middle;
            background-color: #000;
            opacity: 0.8;
            padding: 10px 14px;
            border-radius: 20px;
            color: #fff;
            .upload-btn {
              display: inline-block;
              vertical-align: middle;
              font-size: 16px;
            }
            .label {
              display: inline-block;
              vertical-align: middle;
              font-size: 16px;
            }
          }
        }

        .save-video-text {
          font-size: large;
          line-height: 22px;
        }

        .save-video-tip-pop {
          margin: 50px auto;
          margin-top: 20px;
          color: white;
          width: 90vw;
          text-align: center;
          padding-bottom: 38%;

          .generate-video-loading {
            width: 100%;
            height: 50px;
            position: relative;
            z-index: inherit;
          }

          .save-video-text {
            font-size: large;
            line-height: 22px;
          }

          .download-text {
            // margin-top: 30px;
            font-size: large;
            color: white;

            > span {
              margin-left: 7px;
              font-size: large;
              font-weight: bold;
            }
          }

          .download-image {
            width: 40vw;
            margin: 20px auto;

            span {
              font-size: 100px;
            }
          }
        }

        .save-tip-wrapper {
          width: 90vw;
          margin: 20px auto;
          padding-bottom: 16vh;
          padding-bottom: 16dvh;
          color: #fff;
          text-align: center;

          .save-tip-label {
            font-size: 18px;
            line-height: 22px;
          }

          .save-icon {
            margin: 20px 0;

            i {
              font-size: 100px;
            }
          }
        }

        .bottom-poster-list-content::-webkit-scrollbar {
          display: none;
        }

        .bottom-poster-list {
          box-sizing: border-box;
          padding: 15px 20px 10px 20px;
          width: 100%;
          background: white;
          border-radius: 8px 8px 0 0;
          position: fixed;
          bottom: 0;
          left: 0;

          ::v-deep {
            .van-tabs {
              height: 20vh;
              height: 20dvh;

              .van-tab--active {
                color: var(--custom-color)
              }

              .van-tabs__wrap {
                height: 32px;

                .van-tab__text {
                  display: block;
                  word-break: break-word;
                  white-space: normal;
                  text-align: center;
                }

                .van-tabs__line {
                  display: none;
                }
              }

              .van-tabs__content {
                height: 68%;
                margin-top: 20px;

                .van-tab__pane-wrapper {
                  height: 100%;

                  .van-tab__pane {
                    height: 100%;
                  }
                }
              }
            }
          }

          .bottom-poster-list-content {
            width: 100%;
            height: 100%;
            overflow-x: scroll;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            > :not(:last-child) {
              margin-right: 15px;
            }

            > div {
              position: relative;
              flex-shrink: 0;
              background-repeat: no-repeat !important;
              background-size: cover !important;
              border-radius: 10px;
              width: calc((15vh - 40px) * 314 / 198);
              width: calc((15dvh - 40px) * 314 / 198);
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;

              .poster-item {
                position: relative;
                height: 100%;
                width: 100%;

                > span {
                  position: absolute;
                  font-size: 28px;
                  color: white;
                  border-radius: 50%;
                  border: solid 2px white;
                  display: block;
                  width: 42px;
                  height: 42px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  z-index: 100;
                  top: 30%;
                  left: 33%;
                }

                .delete-poster {
                  display: flex;
                  background-color: #666666;
                  font-size: 12px;
                  position: absolute;
                  right: 0;
                  top: 0;
                  width: 20px;
                  height: 20px;
                  border-bottom-left-radius: 10px;
                  border-top-right-radius: 10px;
                  color: #fff;
                  align-items: center;
                  justify-content: center;
                }

                .icon-video-play {
                  width: 36px;
                  height: 36px;
                  position: absolute;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  top: 34%;
                  left: 37%;

                  > div {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background: rgba($color: #000000, $alpha: 0.6);
                  }

                  img {
                    position: absolute;
                    width: 100%;
                  }
                }
              }
            }
          }
        }

        .poster-list-wrapper {
          width: 100%;
          height: 15vh;
          height: 15dvh;
          padding: 20px;
          border-radius: 8px 8px 0 0;
          box-sizing: border-box;
          background: #fff;
          position: fixed;
          left: 0;
          bottom: 0;

          .poster-list {
            display: flex;
            height: 100%;
            align-items: center;
            overflow-x: scroll;

            .poster {
              flex-shrink: 0;
              width: calc((15vh - 40px) * 314 / 198);
              width: calc((15dvh - 40px) * 314 / 198);
              height: 100%;
              border-radius: 10px;
              background-size: cover;
              background-repeat: no-repeat;
              position: relative;

              &:not(:first-child) {
                margin-left: 15px;
              }

              &.is-active {
                .active-icon {
                  display: block;
                }

                .play-video-icon {
                  display: none;
                }
              }

              .active-icon {
                display: none;
                width: 42px;
                height: 42px;
                border: 2px solid #fff;
                border-radius: 50%;
                color: #fff;
                transform: translate(-50%, -50%);
                line-height: 42px;
                text-align: center;
                position: absolute;
                top: 50%;
                left: 50%;
                z-index: 100;

                i {
                  font-size: 28px;
                }
              }

              .play-video-icon {
                width: 35px;
                height: 35px;
                border-radius: 50%;
                background: rgba($color: #000000, $alpha: 0.6);
                transform: translate(-50%, -50%);
                position: absolute;
                top: 50%;
                left: 50%;
                z-index: 1;

                img {
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }
  }

}
</style>
